import { render, staticRenderFns } from "./autoQueue.vue?vue&type=template&id=2fc01072&scoped=true&"
import script from "./autoQueue.vue?vue&type=script&lang=js&"
export * from "./autoQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc01072",
  null
  
)

export default component.exports